import React from 'react'
import ConnectUs from '../../component/ConnectUs';
import MobileNav from '../../component/MobileNav';
import { Link } from 'react-router-dom';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@500;600&display=swap');

  .ne-page * { box-sizing: border-box; margin: 0; padding: 0; }

  .ne-page {
    min-height: 100vh;
    background: #eaf1fd;
    font-family: 'Sora', sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 1.25rem 5rem;
    margin-top: 55px;
  }

  
  /* CARD */
  .ne-card {
    width: 100%; max-width: 520px;
    background: #fff;
    border-radius: 24px;
    padding: 2.5rem 2.25rem 2rem;
    box-shadow: 0 4px 40px rgba(15,28,46,0.08), 0 1px 4px rgba(15,28,46,0.04);
    border: 1px solid rgba(255,255,255,0.8);
    display: flex; flex-direction: column; align-items: center;
    text-align: center;
  }

  /* ICON RING */
  .ne-icon-ring {
    width: 72px; height: 72px; border-radius: 50%;
    background: rgba(226,75,74,0.08);
    border: 2px solid rgba(226,75,74,0.25);
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 1.5rem;
    animation: ne-pop 0.5s cubic-bezier(0.34,1.56,0.64,1) both;
  }
  @keyframes ne-pop {
    from { transform: scale(0.5); opacity: 0; }
    to   { transform: scale(1);   opacity: 1; }
  }
  .ne-icon-ring svg { width: 34px; height: 34px; fill: none; stroke: #E24B4A; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }

  /* STATUS TAG */
  .ne-tag {
    display: inline-flex; align-items: center; gap: 5px;
    background: rgba(226,75,74,0.08); border: 1px solid rgba(226,75,74,0.22);
    border-radius: 20px; padding: 4px 12px;
    color: #E24B4A; font-size: 11.5px; font-weight: 600;
    margin-bottom: 1.25rem;
  }

  .ne-title {
    font-size: 22px; font-weight: 700; color: #0f1c2e;
    letter-spacing: -0.5px; line-height: 1.25; margin-bottom: 10px;
  }
  .ne-title span { color: #F97316; }
  .ne-sub {
    font-size: 13.5px; color: #6b7a90; line-height: 1.7;
    margin-bottom: 2rem; max-width: 380px;
  }
  .ne-sub strong { color: #E24B4A; font-weight: 600; }

  /* INFO CARDS */
  .ne-info-row {
    display: flex; gap: 10px; width: 100%; margin-bottom: 2rem;
  }
  .ne-info-card {
    flex: 1; padding: 14px 12px; border-radius: 14px;
    border: 1px solid #e8eef7; background: #f7f9fc;
    display: flex; flex-direction: column; align-items: center; gap: 7px;
    text-align: center;
  }
  .ne-info-icon {
    width: 32px; height: 32px; border-radius: 9px;
    display: flex; align-items: center; justify-content: center;
  }
  .ne-info-icon svg { width: 16px; height: 16px; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
  .ne-info-icon.blue { background: rgba(55,138,221,0.12); }
  .ne-info-icon.blue svg { stroke: #378ADD; }
  .ne-info-icon.orange { background: rgba(249,115,22,0.12); }
  .ne-info-icon.orange svg { stroke: #F97316; }
  .ne-info-label { font-size: 11px; color: #9aaabb; font-weight: 500; }
  .ne-info-val { font-size: 13px; font-weight: 600; color: #0f1c2e; }

  /* SECTION DIVIDER */
  .ne-section-title {
    font-size: 11px; font-weight: 600; letter-spacing: 0.7px;
    text-transform: uppercase; color: #9aaabb;
    margin-bottom: 1rem; width: 100%;
    display: flex; align-items: center; gap: 8px;
  }
  .ne-section-title::after { content: ''; flex: 1; height: 1px; background: #e8eef7; }

  /* CONNECT BOX */
  .ne-connect { width: 100%; margin-bottom: 1.75rem; }

  /* BUTTONS */
  .ne-btn-primary {
    display: flex; align-items: center; justify-content: center; gap: 8px;
    width: 100%; height: 50px;
    background: #F97316; color: #fff;
    border: none; border-radius: 14px;
    font-family: 'Sora', sans-serif;
    font-size: 15px; font-weight: 600;
    text-decoration: none; cursor: pointer;
    box-shadow: 0 4px 18px rgba(249,115,22,0.32);
    transition: background 0.18s, transform 0.1s, box-shadow 0.18s;
    margin-bottom: 10px;
  }
  .ne-btn-primary:hover {
    background: #ea6a0a; color: #fff; text-decoration: none;
    box-shadow: 0 6px 24px rgba(249,115,22,0.42);
    transform: translateY(-1px);
  }
  .ne-btn-primary svg { width: 17px; height: 17px; }

  /* TRUST */
  .ne-trust {
    display: flex; align-items: center; justify-content: center;
    gap: 6px; margin-top: 1.25rem;
    font-size: 11.5px; color: #9aaabb;
  }
  .ne-trust svg { width: 13px; height: 13px; }
  .ne-trust-sep { width: 3px; height: 3px; background: #c8d3e2; border-radius: 50%; margin: 0 2px; }

  @media (max-width: 520px) {
    .ne-card { padding: 2rem 1.5rem 1.75rem; }
    .ne-title { font-size: 20px; }
    .ne-info-row { flex-direction: column; }
  }
`;

const IconBolt = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </svg>
);
const IconXCircle = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="15" y1="9" x2="9" y2="15"/>
    <line x1="9" y1="9" x2="15" y2="15"/>
  </svg>
);
const IconClock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);
const IconRefresh = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 4 23 10 17 10"/>
    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
  </svg>
);
const IconDashboard = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
  </svg>
);
const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);

export default function NotEligible() {
  return (
    <>
      <style>{styles}</style>
      <div className="ne-page">
       

        {/* CARD */}
        <div className="ne-card">

          <div className="ne-icon-ring"><IconXCircle /></div>

          <div className="ne-tag">Not eligible at this time</div>

          <h1 className="ne-title">
            Thanks for your showing interest in<br />
            <span>B4Salary</span>
          </h1>

          <p className="ne-sub">
            Unfortunately, you are <strong>not eligible</strong> at the moment due to our internal credit policy. Don't worry — this is temporary.
          </p>

          {/* INFO CARDS */}
          <div className="ne-info-row">
            <div className="ne-info-card">
              <div className="ne-info-icon blue"><IconClock /></div>
              <div className="ne-info-label">Try again in</div>
              <div className="ne-info-val">24 hours</div>
            </div>
            <div className="ne-info-card">
              <div className="ne-info-icon orange"><IconRefresh /></div>
              <div className="ne-info-label">Application</div>
              <div className="ne-info-val">Can be resubmitted</div>
            </div>
          </div>

          {/* CONNECT */}
          <div className="ne-section-title">Need help?</div>
          <div className="ne-connect">
            <ConnectUs />
          </div>

          {/* CTA */}
          <Link to="/journey/dashboard" className="ne-btn-primary">
            <IconDashboard /> Go to dashboard
          </Link>

          {/* TRUST */}
          <div className="ne-trust">
            <IconLock />
            256-bit SSL encrypted
            <span className="ne-trust-sep" />
            Your data is private
            <span className="ne-trust-sep" />
            RBI compliant
          </div>

        </div>
      </div>
      <MobileNav />
    </>
  );
}